import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import type { SyntaxHighlighterProps } from 'react-syntax-highlighter';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import type { MDXContent } from 'mdx/types'; // this is used inside '@mdx/{packages}'

import { Heading } from '@shieldpay/bumblebee/heading';
import { Text } from '@shieldpay/bumblebee/text';

import { CONTENT_IDS } from '../contents-table/utils';

type HeadingProps = ComponentProps<typeof Heading>;

export const MdxFormatter = ({ md: Markdown }: { md: MDXContent }) => (
  <>
    <Heading level="2" variant="headline2" id={CONTENT_IDS.CODE}>
      <FormattedMessage id="hive.titles.code" />
    </Heading>

    <Markdown
      components={{
        code: (props) => (
          <SyntaxHighlighter
            {...(props as SyntaxHighlighterProps)}
            language="jsx"
            style={dark}
          />
        ),
        h1: (props) => (
          <Heading variant="headline1" {...(props as HeadingProps)} />
        ),
        h2: (props) => (
          <Heading variant="headline2" {...(props as HeadingProps)} />
        ),
        h3: (props) => (
          <Heading variant="section" {...(props as HeadingProps)} />
        ),
        h4: (props) => <Heading variant="title" {...(props as HeadingProps)} />,
        p: (props) => <Text {...(props as ComponentProps<typeof Text>)} />,
        bold: (props) => <Text paragraph variant="bodyMedium150" {...props} />,
      }}
    />
  </>
);
